<template>
  <div>
    <ElibraryDetail></ElibraryDetail>
  </div>
</template>

<script>

import ElibraryDetail from "@/components/public-e-library/ElibraryDetail.vue";

export default {
  name: 'ELibraryDetilView',
  components: {
    ElibraryDetail

  },
  data() {
    return {

    }
  },
  methods: {

  }
}
</script>

<style scoped>

</style>